/**
 * Mini workspace thumbnails for the signup role-selection cards.
 * Pure CSS — no real screenshots. Renders a postage-stamp version of
 * the IFA dashboard / Individual home so the user sees what they'll
 * land in before they click Continue with Google.
 *
 * Class names come from pro.css (.thumb / .thumb-nav / .thumb-body /
 * .thumb-strip / .thumb-grid / .thumb-card / .thumb-hero / .thumb-rows
 * / .thumb-row). Don't restyle inline — the design system owns the
 * exact dimensions.
 */
export function ThumbIFA() {
  return (
    <div className="thumb">
      <div className="thumb-nav" />
      <div className="thumb-body">
        <div className="thumb-strip">
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className="thumb-grid">
          <div className="thumb-card gain" />
          <div className="thumb-card loss" />
          <div className="thumb-card gain" />
          <div className="thumb-card warn" />
        </div>
      </div>
    </div>
  );
}

export function ThumbInvestor() {
  return (
    <div className="thumb">
      <div className="thumb-nav" />
      <div className="thumb-body">
        <div className="thumb-hero" />
        <div className="thumb-rows">
          <div className="thumb-row gain" />
          <div className="thumb-row loss" />
          <div className="thumb-row gain" />
        </div>
      </div>
    </div>
  );
}
